import { call, put, delay } from "redux-saga/effects";
import { instructorCourseApi } from "@services/api";
import { deleteDiscountActions, getDiscountsActions } from "../slices";

function* deleteDiscountWorker({ payload }) {
  yield delay(300);
  try {
    yield put(deleteDiscountActions.pending());
    const response = yield call(instructorCourseApi.deleteDiscount, payload);
    yield put(deleteDiscountActions.success(response));

    yield put(getDiscountsActions.pending());
    const responseGet = yield call(instructorCourseApi.getDiscounts, payload);
    yield put(getDiscountsActions.success(responseGet));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(deleteDiscountActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { deleteDiscountWorker };
